module.exports = __webpack_public_path__ + "media/custom/images/pocstock_contribute-step-02-18246fd1aa8615f330f0d0f054beff07.png";